import { Component, ViewChild, TemplateRef, ElementRef, Renderer2, OnChanges, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';


@Component({
  selector: 'app-cr',
  templateUrl: './cr.component.html',
  styleUrls: ['./cr.component.scss']
})

export class CRComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  isProcessing = false;
  getQmsCrVwDetails: any = [];
  isStageUsersSkipped: boolean = false;
  isSaveReport: boolean = false;
  taskStage: any = [];
  taskStageUsers: any = [];
  isAdditionalTabUser: boolean = false;
  getFlexibleFields: boolean = false;

  attachAllDocuments: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly taskActionsHistoryComponent: TaskActionsHistoryComponent,
    public dependencyNavigationService: DependencyNavigationService,

    private readonly elem: ElementRef,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

    this.isAdditionalTabUser = this.qualityService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.appService.getTaskStages(qualityService.activityId, 0).subscribe((stage: any) => {
      this.taskStage = stage;
      this.isStageUsersSkipped = !stage.length;
    })
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  skipValidationsWhileSwitchingUser: boolean = false;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.qualityService.selectedTabName = $event.tab.textLabel;
    this.tabIndex = $event.index;
    this.setAesthetic();
    this.previousTabValue = $event.tab.textLabel;
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  previousTabValue: any;
  getColor(status: any) {
    if (status !== undefined && status !== null) {
      if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
        return 'red';
      } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
        return 'orange';
      } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
        return 'green';
      } else {
        return '#005c8a';
      }
    } else {
      return '#005c8a';
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  addworkflow: boolean = false;
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
  }

  $present_future_config = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  onExpectedToBeStartedOnChange() {
    if (this.qualityService.activity.expcetedClosureOn && (this.qualityService.activity.expcetedClosureOn < this.qualityService.activity.expectedToBeStartedOn)) this.qualityService.activity.expcetedClosureOn = null;
  }

  $expected_closure_dynamic_config() {
    return {
      ...this.commonDateConfig,
      minDate: this.qualityService.activity.expectedToBeStartedOn ? new Date(this.qualityService.activity.expectedToBeStartedOn) : new Date()
    }
  }

  reportName: any;
  pdfDetailSearchText: string = '';
  isDepartmentOdd: any = null;
  isReasonForChangeTypeOdd: any = null;
  isOwnerOdd: any = null;
  isCRTypeOdd: any = null;
  isRequestedAtOdd: any = null;
  isCoreBusinessOdd: any = null;
  isQAOdd: any = null;
  isDhOdd: any = null;

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  @ViewChild('reason') reason: MatSelect;
  isAllReasonSelected = false;
  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) {
        this.businessArea.options.forEach((item: MatOption) => item.select());
      } else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue);
      });
    } else if (value == 'reason') {
      if (this.isAllReasonSelected) this.reason.options.forEach((item: MatOption) => item.select());
      else {
        this.reason.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.crPageAllDropdownValues.reasonForChangeValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('reasonForChange-validation', this.qualityService.crPageAllDropdownValues.reasonForChangeValue)
      });
    }
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;
  /* Note : if (userBeingSwitched) param values changed then regarding names need to be changed in SwitchuserComponent too */

  async openSwitchUser(userBeingSwitched: any) {
    this.isProcessing = true;
    if (this.qualityService.activity.status == "In Progress" && userBeingSwitched != "Owner" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }

    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Owner") {
      this.message.switchedUser = this.qualityService.crPageAllDropdownValues.ownerValue;
      this.message.switchUserCurrentValue = this.qualityService.crPageAllDropdownValues.ownerValue;
      this.message.switchUserdropDownList = this.ownerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.qualityService.crPageAllDropdownValues.qaUserValue;
      this.message.switchUserCurrentValue = this.qualityService.crPageAllDropdownValues.qaUserValue;
      this.message.switchUserdropDownList = this.qaDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    else if (userBeingSwitched == "Department Head") {
      this.message.switchedUser = this.qualityService.crPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserCurrentValue = this.qualityService.crPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserdropDownList = this.departmentHeadDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "CR");
  };

  onChildValueEmitted() {
    this.skipValidationsWhileSwitchingUser = true;
    this.switchUserComponent.saveMethod();
    this.update();
  };

  onTagChildValueEmitted() {
    /* Something goes here */
  };

  backbtn() {
    this.message.breadcrumbData.fourthLevel = "";
    this.message.breadcrumbData.fourthLevel = null;
    this.router.navigate(['dashboard/ActivityCR']);
  }

  crNoValue: any;
  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  taskStagesList: any = [];

  dropDownForReasonForChange: any = [];
  businessAreaName: any;

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  activityData: boolean = false;
  async openAddWorkflow() {
    if (this.qualityService.activity.status == "In Progress" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: 'Activity' })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addworkflow = true;
    this.isProcessing = false;
  };

  onchangeTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('changeType-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
          if (response?.toBeStartedInDays != null) {
            let date = new Date();
            date.setDate(date.getDate() + response.toBeStartedInDays);
            this.cr.expectedToBeStartedOn = date;
          }
          if (response?.toBeClosedInDays != null) {
            let date = new Date();
            this.cr.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
            this.cr.expcetedClosureOn = date;
          }
          this.isProcessing = false;
        })
      }
    }
  }

  visibleReasonForChangeIfOthers: boolean = false;

  selectedOwnerDisplayExp: any;
  selectedOwnerValueExp: any;
  selectedQaUserValueExp: any = [];
  selectedQaUserDisplayExp: any = [];
  selecteddepartmentHeadUserValueExp: any = [];
  cols: any;
  getQmsBusinessAreaDetail: any = [];
  filteredBusinessAreaValue: any = [];
  listOfUsers: any = [];
  editableDescriptionField: boolean;
  loggedOwner: boolean;
  ECPerformer: boolean;
  visibleDescriptionSection: boolean;
  objForDocuments: any;

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qualityService.moduleName == 'CR') {
        this.initiate();
      }
    });
  }

  private initiate(): void {
    this.isProcessing = true;
    this.main();
    this.getDynamicLabel();
    this.ngOnChangesReportFooter();
    this.clearDropdowns();
    this.selectedTabIndex = 0;
  }

  label: any = [];
  dynamicLabel: any = null;
  getDynamicLabel() {

    const data = {
      tableName: 'QMS_CR_GRID_VW',
      moduleName: 'CR',
      gridName: 'CR',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qualityService.activityDynamicLabel = acc;
          return acc;
        }, {});
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  clearDropdowns() {
    Object.keys(this.qualityService.crPageAllDropdownValues).forEach(key => {
      if (key === 'coreBusinessAreaNameValue' || key === 'reasonForChangeValue') {
        this.qualityService.crPageAllDropdownValues[key] = [];
      } else {
        this.qualityService.crPageAllDropdownValues[key] = null;
      }
    })
  }

  dropDownForDepartment: any = [];
  dropDownForDesignation: any = [];
  dropDownForChangeType: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  ownerList: any = [];
  qaList: any = [];
  reasonForChangeList: any = [];
  departmentHeadList: any = [];
  ecPerformerList: any = [];

  departmentCodeDropdown: any = [];
  designationCodeDropdown: any = [];
  changeTypeDropdown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  ownerDropdown: any = [];
  qaDropdown: any = [];
  reasonForChangeDropdown: any = [];
  departmentHeadDropdown: any = [];

  departmentSearchText: string = '';
  designationSearchText: string = '';
  changeTypeSearchText: string = '';
  requestedAtSearchText: string = '';
  coreBusinessSearchText: string = '';
  ownerSearchText: string = '';
  qaSearchText: string = '';
  reasonForChangeSearchText: string = '';
  departmentHeadSearchText: string = '';

  main() {

    this.getFlexibleFields = false;
    this.qualityService.activity = {};
    this.qualityService.activityDynamicButtonList = [];
    this.objForDocuments = { id: this.qualityService.activityId, pagename: "Activity" };

    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');

    this.dropDownForDepartment.length && this.selectBoxForDepartment();
    this.dropDownForDesignation.length && this.selectBoxForDesignation();

    const groupId = this.qualityService.selectedActivityGroupId;
    const groupDetailId = this.qualityService.selectedGroupDetailData.groupDetailId;
    const moduleName = this.qualityService.moduleName;

    const getRequestedAt$ = this.appService.getAllQmsBusinessAreas();
    const getOwner$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Owner');
    const getQa$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'QA');
    const getDepartmentHead$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Department Head');
    const getEcPerformer$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer');
    const getReasonForChange$ = this.appService.getCodeListsByGroup("REASON_FOR_CHANGE");
    const getParallelWorkflowList$ = this.appService.getWorkflowByRefNo(this.qualityService.activityId);
    const getTypeSettings$ = this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId);
    const getreportTemplateList$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, groupId);
    const getReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", groupId);

    forkJoin([
      getRequestedAt$, getOwner$, getQa$, getDepartmentHead$, getEcPerformer$, getReasonForChange$, getParallelWorkflowList$, getTypeSettings$, getreportTemplateList$, getReportImage$, getReportLogo$
    ]).pipe(
      switchMap((
        [requestedAt, owner, qa, departmentHead, ecPerformer, reasonForChange, parallelWorkflow, typeSettings, reportTemplate, reportImage, reportLogo]) => {

        this.getQmsBusinessAreaDetail = requestedAt;
        this.dropDownForRequestedAt = this.getQmsBusinessAreaDetail.filter((item: any) => item.module === this.qualityService.moduleName);

        this.ownerList = owner;
        /*  selectBoxForOwner function has been called after activity get call to load group owners */

        this.qaList = qa;
        this.qaList.length && this.selectBoxForQa();

        this.ecPerformerList = ecPerformer;

        this.reasonForChangeList = reasonForChange;
        this.reasonForChangeList.length && this.selectBoxForReasonForChange();

        this.departmentHeadList = departmentHead;
        this.departmentHeadList.length && this.selectBoxForDepartmentHead();

        this.parallelWorkflowList = parallelWorkflow;

        this.dropDownForChangeType = typeSettings;
        this.dropDownForChangeType.length && this.selectBoxForChangeType();

        this.dropDownDataForReportTemplate = reportTemplate;
        this.selectBoxForReportTemplate();

        this.dropDownDataForReportLogo = reportLogo;

        this.organizationReportImageDetails = reportImage;
        this.selectBoxForReportLogo();

        return this.appService.getCrByCrNo(this.qualityService.activityId);
      })
    ).subscribe((crDetails: any) => {

      this.cr = crDetails;
      this.qualityService.activity = crDetails;

      this.cr.createdOn = this.cr.createdOn ? new Date(this.cr.createdOn) : null;
      this.cr.expcetedClosureOn = this.cr.expcetedClosureOn ? new Date(this.cr.expcetedClosureOn) : null;
      this.cr.expectedToBeStartedOn = this.cr.expectedToBeStartedOn ? new Date(this.cr.expectedToBeStartedOn) : null;
      this.cr.effectiveOn = this.cr.effectiveOn ? new Date(this.cr.effectiveOn) : null;
      this.cr.startedOn = this.cr.startedOn ? new Date(this.cr.startedOn) : null;
      this.cr.completedOn = this.cr.completedOn ? new Date(this.cr.completedOn) : null;
      this.cr.lastActionOn = this.cr.lastActionOn ? new Date(this.cr.lastActionOn) : null;
      this.cr.ownerAcceptanceRequestedOn = this.cr.ownerAcceptanceRequestedOn ? this.cr.ownerAcceptanceRequestedOn.split('T')[0] : null;
      this.cr.ownerApprovedOn = this.cr.ownerApprovedOn ? this.cr.ownerApprovedOn.split('T')[0] : null;

      this.message.showActionSection = this.cr.actionItemsReqd = this.cr.actionItemsReqd == "Y";
      this.message.showPreActionsTab = this.cr.preActionItemsReqd = this.cr.preActionItemsReqd == "Y";
      this.cr.effectivenessCheckReqd = this.cr.effectivenessCheckReqd == "Y";
      this.cr.isRiskCalculationReqd = this.cr.isRiskCalculationReqd == "Y";
      this.message.showRiskTab = this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

      this.qualityService.activity = this.cr;

      this.waitForObjectReady(() => !!this.cr?.crNo, 10000, 100)
        .then(() => { this.getFlexibleFields = true; })
        .catch(() => { this.getFlexibleFields = false; });

      this.getStageUsers();
      this.selectBoxForRequestedAt();
      this.ownerList.length && this.selectBoxForOwner();
      this.setDropdown();
      this.getDynamicButtons();
      this.ngOnChanges();
    });
  }

  waitForObjectReady(checkFn: () => boolean, timeout = 10000, interval = 100): Promise<void> { return new Promise((resolve, reject) => { const start = Date.now(); const timer = () => { if (checkFn()) { resolve(); } else if (Date.now() - start >= timeout) { reject(new Error('Timeout: activity not fully populated.')); } else { setTimeout(timer, interval); } }; timer(); }); }

  selectBoxForDepartment() {
    this.departmentCodeDropdown = this.dropDownForDepartment?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  selectBoxForDesignation() {
    this.designationCodeDropdown = this.dropDownForDesignation?.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  selectBoxForChangeType() {
    this.changeTypeDropdown = this.dropDownForChangeType?.map((type: any) => ({
      valueExp: type.type,
      displayExp: type.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  isBusinessAreaEmpty: boolean = false;
  selectBoxForRequestedAt() {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == this.cr.requestedAt);
    this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;

    if (!this.isBusinessAreaEmpty) {
      this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
      this.selectBoxForCoreBusinessAreaName();
    }
  }

  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requestedAt-validation', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      }
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue)
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue.length;
      });
  }

  /* Note : Group Owner userId is handled as 100 */
  selectBoxForOwner() {
    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y' || this.cr.owner == 100;
    const owners = this.ownerList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    const status = ['Draft', 'Department Head Requested More Info.', 'Department Head Rejected', 'Department Head Approved', 'QA Requested More Info.', 'QA Acceptance Rejected', 'Owner Requested More Info.', 'Pending Department Head Approval', 'QA Accepted', 'Pending QA Acceptance', 'Owner Acknowledgement Pending'];
    const isStatusPassed = status.includes(this.cr.status);

    setTimeout(() => { this.ownerDropdown = (groupOwner && isStatusPassed) ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners; }, 500);
  }

  onOwnerSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('owner-validation', item);
  }

  selectBoxForQa() {
    this.qaDropdown = this.qaList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onQaUserSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('qaUser-validation', item);
  }

  selectBoxForReasonForChange() {
    this.reasonForChangeDropdown = this.reasonForChangeList?.map((reason: any) => ({
      valueExp: reason.codelistCode,
      displayExp: reason.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onReasonForChangeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reasonForChange-validation', item);
      if (item) {
        if (item.displayExp == 'Others') [this.visibleReasonForChangeIfOthers, this.qualityService.activity.reasonForChange] = [true, ''];
        else this.visibleReasonForChangeIfOthers = false;
        setTimeout(() => {
          this.isAllReasonSelected = this.reasonForChangeDropdown.length == this.qualityService.crPageAllDropdownValues.reasonForChangeValue.length;
        });
      }
    }
  }

  selectBoxForDepartmentHead() {
    this.departmentHeadDropdown = this.departmentHeadList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDhUserSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('dhUser-validation', item);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    if (fieldId == 'changeType-validation' && !this.isTypeMandatory) return;

    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.cr.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.cr.crNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.setAesthetic();
      });
    } else {
      this.setAesthetic();
    }
  }

  setDropdown() {

    const matchingRequestedAt = this.dropDownForRequestedAt?.find((item: any) => item.taskRequestedAt === this.cr.requestedAt);
    if (!matchingRequestedAt) {
      this.isRequestedAtOdd = this.cr.requestedAt;
      this.requestedAtDropdown.push({
        valueExp: this.cr.requestedAt,
        displayExp: this.cr.requestedAt
      })
    }

    this.qualityService.crPageAllDropdownValues.requestedAtValue = this.businessAreaName = this.cr.requestedAt;

    const selectedBusinessArea = this.isBusinessAreaEmpty ? this.cr.coreBusinessAreaName : this.cr.coreBusinessAreaName?.split(',') ?? [];
    this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue = selectedBusinessArea;
    setTimeout(() => {
      if (!this.isBusinessAreaEmpty) this.isAllBusinessAreaSelected = this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue == this.coreBusinessAreaNameDropdown.length;
    }, 1500);

    if (this.cr.deptCode) {
      let matchingDepartment = this.dropDownForDepartment.find((x: any) => x.codelistCode === this.cr.deptCode);
      if (matchingDepartment) {
        this.isDepartmentOdd = null;
      } else {
        this.isDepartmentOdd = this.cr.deptCode;
        this.departmentCodeDropdown.push({
          valueExp: this.cr.deptCode,
          displayExp: this.cr.deptCode
        });
      }
      this.qualityService.crPageAllDropdownValues.departmentValue = this.cr.deptCode;
    }

    if (this.cr.departmentHead) {
      let matchingDepartmentHead = this.departmentHeadDropdown.find((x: any) => x.valueExp === this.cr.departmentHead);
      if (matchingDepartmentHead) {
        this.isDhOdd = null;
      } else {
        this.isDhOdd = this.cr.departmentHead;
        this.departmentHeadDropdown.push({
          valueExp: this.cr.departmentHead,
          displayExp: this.cr.departmentHeadUserName
        })
      }
      this.qualityService.crPageAllDropdownValues.departmentHeadUserValue = this.cr.departmentHead;
    }

    if (this.cr.qaUser) {
      let matchingQa = this.qaDropdown.find((x: any) => x.valueExp === this.cr.qaUser);
      if (matchingQa) {
        this.isQAOdd = null;
      } else {
        this.isQAOdd = this.cr.qaUser;
        this.qaDropdown.push({
          valueExp: this.cr.qaUser,
          displayExp: this.cr.qaUserName
        })
      }
      this.qualityService.crPageAllDropdownValues.qaUserValue = this.cr.qaUser;
    }

    if (this.cr.owner || this.cr.owner == 0) {
      setTimeout(() => {
        let matchingOwner = this.ownerDropdown.find((x: any) => x.valueExp === this.cr.owner);
        if (matchingOwner) {
          this.isOwnerOdd = null;
        } else {
          this.isOwnerOdd = this.cr.owner;
          this.ownerDropdown.push({
            valueExp: this.cr.owner,
            displayExp: this.cr.ownerUserName
          })
        }
      }, 750)
      this.qualityService.crPageAllDropdownValues.ownerValue = this.cr.owner;
    }

    if (this.cr.changeTypeCode) {
      let matchingType = this.changeTypeDropdown.find((x: any) => x.valueExp === this.cr.changeTypeCode);
      if (matchingType) {
        this.isCRTypeOdd = null;
      } else {
        this.isCRTypeOdd = matchingType;
        this.changeTypeDropdown.push({
          valueExp: matchingType,
          displayExp: matchingType
        })
      }
      this.qualityService.crPageAllDropdownValues.changeTypeValue = this.cr.changeTypeCode;
    }

    this.qualityService.crPageAllDropdownValues.reasonForChangeValue = this.cr.reasonForChangeCode?.split(',') ?? []
    this.visibleReasonForChangeIfOthers = this.qualityService.crPageAllDropdownValues.reasonForChangeValue.includes('Others')
    setTimeout(() => {
      this.isAllReasonSelected = this.reasonForChangeDropdown.length == this.qualityService.crPageAllDropdownValues.reasonForChangeValue.length;
    });

  }

  private processButtonLabels(buttonLabels: string[] | null): string[] {
    const labels = buttonLabels ? [...buttonLabels] : [];
    labels.unshift("Cancel");  // Always add Cancel
    this.qualityService.activityDynamicButtonList = labels;

    // Reset flags
    this.qualityService.showflexifieldshow = false;
    this.qualityService.activitySaveButton = false;

    for (const element of labels) {
      if (/Submit|Review|Approve|Accept/.test(element)) {
        this.qualityService.showflexifieldshow = true;
      }
      if (element === "Save") {
        this.qualityService.activitySaveButton = true;
      }
    }

    return labels;
  }

  private getDynamicButtons() {
    const obj = {
      activityId: this.message.activityId,
      moduleName: this.qualityService.moduleName,
      status: this.cr.status
    }

    this.appService.getQmsButtons(obj).subscribe((data: any) => {
      this.qualityService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qualityService.activitySaveButton = false;

      if (data.resultType === "S") {
        this.qualityService.showflexifieldshow = false;
        this.isProcessing = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qualityService.activityButtonLabels = data;
        this.buttonLabels = this.processButtonLabels(data.buttonLabels?.split(",") || null);

      } else {
        this.buttonLabels = this.processButtonLabels(null);
        this.showSnackBar(data.result, data.resultType);
      }
    });
  }

  parallelWorkflowList: any = null;
  ngOnChanges() {
    this.qualityService.refereshBreadCrumb = true;
  }

  limitCharacters(event: Event, field: string) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    const fieldMapping: { [key: number]: string[] } = {
      1000: ['REASON_FOR_CHANGE', 'REQUESTED_AT'],
      400: ['SHORT_DESCRIPTION'],
      4000: ['TYPE_UPDATE_JUSTIFICATION']
    };

    let charLimit = 4000;
    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }
    if (textLength > charLimit) {
      this.showSnackBar(`Maximum ${charLimit} characters allowed!`, 'E');
      target.value = target.value.substring(0, charLimit);

      if (field === 'SHORT_DESCRIPTION') {

        this.qualityService.activity.shortDescription = target.value;
      }
    }
  }

  scrollToMandatoryField: any;
  scrollToMandatoriesField(value: any) {
    this.scrollToMandatoryField = document.getElementById(value) as HTMLInputElement;
    setTimeout(() => this.scrollToMandatoryField.scrollIntoView(), 0);
  }

  userTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  utcDate: any = null;

  fieldValidation(elementIds?: string[]) {
    if (elementIds && elementIds.length > 0) {
      // Use the passed array of IDs
      elementIds.forEach((elementId) => {
        const element = document.getElementById(elementId) as HTMLInputElement;
        if (element) {
          element.style.color = 'red';
        }
      });
    }
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  skipValidation: boolean = false;
  save() {
    this.skipValidation = true;
    this.update();
  }

  async update(): Promise<boolean> {
    this.qualityService.validatedCrArray = [];
    let validationPromises: any[] = [];

    if (!this.skipValidationsWhileSwitchingUser && !this.skipValidation) {
      validationPromises.push(
        { condition: this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y' && !this.qualityService.crPageAllDropdownValues.departmentValue, id: 'department-validation' },
        { condition: !this.qualityService.crPageAllDropdownValues.ownerValue, id: 'owner-validation' },
        { condition: !this.qualityService.crPageAllDropdownValues.requestedAtValue, id: 'requestedAt-validation' },
        { condition: !this.qualityService.crPageAllDropdownValues.coreBusinessAreaNameValue.length, id: 'coreBusinessArea-validation' },
        { condition: !this.qualityService.crPageAllDropdownValues.changeTypeValue && this.isTypeMandatory, id: 'changeType-validation' },
        { condition: this.dynamicLabel['REASON_FOR_CHANGE_CODE'].isRemovable != 'Y' && (!this.qualityService.crPageAllDropdownValues.reasonForChangeValue.length), id: 'reasonForChange-validation' },
        { condition: this.dynamicLabel['REASON_FOR_CHANGE_CODE'].isRemovable != 'Y' && (this.qualityService.crPageAllDropdownValues.reasonForChangeValue.length && this.qualityService.crPageAllDropdownValues.reasonForChangeValue.join(',').includes('Others') && !this.qualityService.activity.reasonForChange), id: 'reasonForChangeIfOthers-validation' },
        { condition: !this.qualityService.activity.expcetedClosureOn, id: 'expcetedClosureOn-validation' },
        { condition: this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && !this.qualityService.activity.expectedToBeStartedOn, id: 'expectedToBeStartedOn' },
        { condition: !this.qualityService.activity.shortDescription, id: 'shortDescription-validation' },
        {
          condition: this.dynamicLabel['CHANGE_DESCRIPTION'].isRemovable != 'Y' && (!this.qualityService.activity.changeDescription || this.isContentEmpty(this.qualityService.activity.changeDescription)),
          id: 'changeDescription-validation'
        },
        {
          condition: this.dynamicLabel['CHANGE_JUSTIFICATION'].isRemovable != 'Y' && (!this.qualityService.activity.changeJustification || this.isContentEmpty(this.qualityService.activity.changeJustification)),
          id: 'changeJustification-validation'
        },
        ...(this.message.showCRDetailsSection ? [
          {
            condition: !this.qualityService.activity.currentState || this.isContentEmpty(this.qualityService.activity.currentState),
            id: 'currentState-validation'
          },
          {
            condition: !this.qualityService.activity.proposedChange || this.isContentEmpty(this.qualityService.activity.proposedChange),
            id: 'proposedChange-validation'
          },
          {
            condition: this.dynamicLabel['IMPACTED_PRODUCT_AND_PROCESS'].isRemovable != 'Y' && (!this.qualityService.activity.impactedProductAndProcess || this.isContentEmpty(this.qualityService.activity.impactedProductAndProcess)),
            id: 'impactedProductAndProcess-validation'
          }
        ] : []),
        { condition: this.cr.qaUser != 0 && !this.qualityService.crPageAllDropdownValues.qaUserValue, id: 'qaUser-validation' },
        { condition: this.cr.departmentHead != 0 && !this.qualityService.crPageAllDropdownValues.departmentHeadUserValue, id: 'dhUser-validation' },
      );
    }

    const invalidIds = validationPromises.filter(v => v.condition).map(v => v.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    }

    try {
      await Promise.all(validationPromises);

      const isValidCr = !invalidIds.length;
      const isValidFlexibleFields = !this.skipValidationsWhileSwitchingUser && this.flexibleComponent.mandatoryValidation();
      const isValid = isValidCr && !isValidFlexibleFields;

      if (isValid) {
        const obj = await this.prepareObj(this.qualityService.activity, this.qualityService.crPageAllDropdownValues);
        const result = await this.execute(obj); // wait for API
        return result;
      } else {
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        return false;
      }
    } catch (error) {
      console.error('Error occurred during validation:', error);
      return false;
    }
  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  async prepareObj(cr: any, dropDown: any) {
    return {
      groupId: cr.groupId,
      crNo: cr.crNo,
      initiatedBy: this.qualityService.crPageAllDropdownValues.initiatedBy,
      qaUser: dropDown.qaUserValue ?? 0,
      departmentHead: dropDown.departmentHeadUserValue ?? 0,
      deptCode: dropDown.departmentValue ?? null,
      owner: dropDown.ownerValue ?? null,
      requestedAt: dropDown.requestedAtValue ?? null,
      coreBusinessAreaName: this.isBusinessAreaEmpty ? dropDown.coreBusinessAreaNameValue : dropDown.coreBusinessAreaNameValue?.join(','),
      changeTypeCode: dropDown.changeTypeValue ?? null,
      reasonForChange: cr.reasonForChange,
      reasonForChangeCode: this.reasonForChangeDropdown.length ? dropDown.reasonForChangeValue.join(',') : dropDown.reasonForChangeValue,
      shortDescription: cr.shortDescription,
      changeDescription: cr.changeDescription,
      changeJustification: cr.changeJustification,
      expcetedClosureOn: this.formatDate(cr.expcetedClosureOn),
      effectiveOn: this.formatDate(cr.effectiveOn),
      startedOn: cr.startedOn,
      completedOn: this.formatDate(cr.completedOn),
      actionItemsReqd: this.mapBooleanToYN(cr.actionItemsReqd),
      preActionItemsReqd: this.mapBooleanToYN(cr.preActionItemsReqd),
      effectivenessCheckReqd: this.mapBooleanToYN(cr.effectivenessCheckReqd),
      isRiskCalculationReqd: this.mapBooleanToYN(cr.isRiskCalculationReqd),
      currentState: cr.currentState,
      proposedChange: cr.proposedChange,
      impactedProductAndProcess: cr.impactedProductAndProcess,
      riskAssessment: cr.riskAssessment,
      expectedToBeStartedOn: this.formatDate(cr.expectedToBeStartedOn),
      typeUpdateJustification: cr.typeUpdateJustification
    }
  }

  execute(obj: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.isProcessing = true;

      this.appService.updateCr(obj).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;

          if (Response.resultType === 'S') {
            this.ngOnInit();

            if (this.skipValidationsWhileSwitchingUser) {
              this.skipValidationsWhileSwitchingUser = false;
            } else if (this.flexibleComponent.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qualityService.activityId);
            }

            if (this.qualityService.isUpdatingCrThroughDynBtn) {
              this.qualityService.isUpdatingCrThroughDynBtn = false;
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }

            this.skipValidation && (this.skipValidation = false);
            resolve(true);

          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
            resolve(false);
          }
        },
        error: (error: Error) => {
          this.isProcessing = false;
          console.error('Execution error:', error);
          reject(new Error('Error Occurred'));
        }
      });
    });
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  };

  validation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }


  cr: any = {};

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  @ViewChild('taskActiosHistoryPopup', { static: true }) taskActiosHistoryPopup: TemplateRef<any>;

  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  visibleTaskActiosHistoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  taskActiosHistoryPopupConfig = {
    width: '130%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '90vw',
  };
  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'Detail',
      labelName: "Tag",
      tagRef: this.qualityService.SelectedGroupNameAndValue[0].groupCode + "-" + this.cr.crId
    }
    this.homepagetagComponent.openpopup(data);
  }

  openTopicPopup() {
    this.message.communicatingFrom = this.qualityService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  openTaskActionsHistory() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleTaskActiosHistoryPopup = this.dialog.open(this.taskActiosHistoryPopup, this.taskActiosHistoryPopupConfig);
  }

  cancelTaskActiosHistoryPopup() {
    this.visibleTaskActiosHistoryPopup.close();
  }


  // Export Report
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = this.dropDownDataForReportTemplate?.map((template: any) => ({
      valueExp: template?.qmsReportTemplateVwPk.templateId,
      displayExp: template?.templateName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  templateid: number;
  onReportTemplateSelect(item: any) {
    this.templateid = item.valueExp;
    if (this.reportTemplatefieldValidation1 != undefined) {
      this.reportTemplatefieldValidation1.style.color = '#005c8a';
    }
  }
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportTemplatefieldValidation1 != undefined) {
        this.reportTemplatefieldValidation1.style.color = '#005c8a';
      }

    }
  }
  logoid: number;
  onReportLogoSelect(item: any) {
    this.logoid = item.valueExp;
    if (this.reportLogofieldValidation1 != undefined) {
      this.reportLogofieldValidation1.style.color = '#005c8a';
    }
  }
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogofieldValidation1 != undefined) {
        this.reportLogofieldValidation1.style.color = '#005c8a';
      }

    }
  }

  openExportPopup() {
    for (const element of this.dropDownDataForReportTemplate) {
      if (element.isDefault == 'Y') {
        this.selectedReportTemplateValue = [{
          valueExp: element.qmsReportTemplateVwPk.templateId,
          displayExp: element.templateName
        }]
      }
    }
    this.selectedReportTemplateValue = null;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }

  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getCrByCrNo(this.qualityService.activityId).subscribe((cr: any) => {
        this.cr.expcetedClosureOn = this.qualityService.activity.expcetedClosureOn = new Date(cr.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  reportTemplatefieldValidation1: any;
  reportLogofieldValidation1: any;

  exportReportGenerateFuntion() {
    this.reportTemplatefieldValidation1 = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    this.reportLogofieldValidation1 = document.getElementById('reportLogo-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};
      this.cr.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.cr.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qualityService.activity.groupId + "",

        "gridName": "CR",
        "templateId": this.selectedReportTemplateValue ?? null,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "CR_Report",
        "currentStatus": this.qualityService.activity.status,
        "groupName": thirdL[1],
        "Crid": this.message.activityId,
        "version": "0",
        "crId": this?.qualityService?.activity?.crId,
        "templateName": this.selectedReportTemplateValue ?? null
      }
      this.isProcessing = true;
      this.appService.genRateCrReport(data1).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;
        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplatefieldValidation1.style.color = 'red';
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  onworkflowChildValueEmitted() {
    this.addworkflow = false;
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Change Description': this.dynamicLabel?.['CHANGE_DESCRIPTION']?.fieldName,
      'Change Justification': this.dynamicLabel?.['CHANGE_JUSTIFICATION']?.fieldName,
      'Current State': this.dynamicLabel?.['CURRENT_STATE']?.fieldName,
      'Proposed Change': this.dynamicLabel?.['PROPOSED_CHANGE']?.fieldName,
      'Impacted Product And Process': this.dynamicLabel?.['IMPACTED_PRODUCT_AND_PROCESS']?.fieldName,
      'Risk Assessment': this.dynamicLabel?.['RISK_ASSESSMENT']?.fieldName,
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  @ViewChild(ModuletypeComponent) moduletypeComponent!: ModuletypeComponent;
  openmoduleType: boolean = false;
  moduleTypeData: any;
  value: any;
  //openpopup
  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.changeTypeDropdown,
      moduleTypeValue: this.qualityService.crPageAllDropdownValues.changeTypeValue,
      expcetedClosureOn: this.qualityService.crPageAllDropdownValues.expcetedClosureOn,
      expectedToBeStartedOn: this.qualityService.crPageAllDropdownValues.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['CHANGE_TYPE_CODE'].fieldName,
      moduleStartedOnName: this.dynamicLabel['STARTED_ON'].fieldName,
      moduleclosedOnName: this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openmoduleType = true;
    this.moduletypeComponent.openpopup(this.moduleTypeData);
    //
  }

  onModuleTypeEmitted($event: any) {
    this.openmoduleType = false;
    this.qualityService.crPageAllDropdownValues.changeTypeValue = $event.moduleType;
    this.qualityService.activity.expcetedClosureOn = $event.expcetedClosureOn;
    this.qualityService.activity.expectedToBeStartedOn = $event.expectedToBeStartedOn;
    this.qualityService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.skipValidation = true;
    this.update();
  }

  getEffectiveOnAesthetic() {
    const { status, owner } = this.qualityService.activity;

    if (status != 'In Progress' && status != 'Closed') {
      return true;
    } else {
      return owner != +this.message.getUserId();
    }
  }

  isFrozen: boolean = false;
  isUsersLock: boolean = false;
  showUpdateType: boolean = false;
  isUpdateType: boolean = false;
  setAesthetic() {
    const loggedUserId = this.message.getUserId();
    const { initiatedBy, owner, qaUser, departmentHead, status, actionItemsReqd, preActionItemsReqd, isRiskCalculationReqd, effectivenessCheckReqd } = this.qualityService.activity;

    const isInitiator = initiatedBy == +loggedUserId!;
    const isOwner = owner == +loggedUserId!;
    const isQa = qaUser == +loggedUserId!;
    const isEditableByQa = this.qualityService.selectedGroupDetailData.editableByQA == 'Y';
    const isDeptHead = departmentHead == +loggedUserId!;
    const isEditableByDeptHead = this.qualityService.selectedGroupDetailData.editableByDepartmentHead == "Y";
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByReviewer = this.qualityService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByApprover = this.qualityService.selectedGroupDetailData.editableByApprovers == "Y";
    const isEcPerformer = this.message.isEcPerformer = this.ecPerformerList.find((user: any) => user.userId === +loggedUserId!);
    const isPreActions = preActionItemsReqd;
    const isActions = actionItemsReqd;
    const isRisk = isRiskCalculationReqd && this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

    this.qualityService.elite_AccessToClosure_Reviewer_Approver = status == "In Progress" && isOwner;
    this.message.showCRDetailsSection = effectivenessCheckReqd;
    this.isUsersLock = true;

    switch (status) {
      case 'Draft':
      case 'Department Head Requested More Info.':
      case 'Department Head Rejected':
      case 'QA Requested More Info.':
      case 'QA Acceptance Rejected':
      case 'Owner Requested More Info.':
        this.draft_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending Department Head Approval':
        this.dept_head_approval_aesthetic(isDeptHead, isEditableByDeptHead, isPreActions, isActions, isRisk);
        break;

      case 'Department Head Approved':
      case 'QA Accepted':
        this.dept_head_approved_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Acceptance':
        this.pending_qa_acceptance_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Approval':
        this.pending_qa_approval_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Owner Acknowledged':
      case 'QA Rejected':
      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
      case 'Revoked':
      case 'Reopened':
        this.owner_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'QA Approved':
        this.qa_approved_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'Pending Review':
      case 'Review Inprogress':
        this.initial_review_aesthetic(isReviewer, isEditableByReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Approval':
      case 'Approval Inprogress':
        this.initial_approval_aesthetic(isApprover, isEditableByApprover, isPreActions, isActions, isRisk);
        break;

      case 'In Progress':
        this.inprogress_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Review':
      case 'Closure Review Inprogress':
        this.closure_review_aesthetic(isReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Approval':
      case 'Closure Approval Inprogress':
        this.closure_approval_aesthetic(isApprover, isPreActions, isActions, isRisk);
        break;

      case 'Pending Delete Approval':
      case 'Pending Reopen Approval':
      case 'Pending Obsolete Approval':
      case 'Pending Revoke Approval':
      case 'Obsoleted':
      case 'Closed':
        this.freeze_aesthetic_A(isOwner, isPreActions, isActions, isRisk, status);
        break;

      case 'Owner Acknowledgement Pending':
      case 'Deleted':
        this.freeze_aesthetic_B(isPreActions, isActions, isRisk);
        break;

    }

    if (this.cr.status === 'Closed') {
      this.appService.getQmsTasksEC(this.qualityService.activityId).subscribe((data: any) => {
        this.message.showEffectiveSection = (data.length > 0) || this.qualityService.activity.effectivenessCheckReqd;
        this.message.showEffectiveActionButtons = isEcPerformer || isOwner;
      })
    } else {
      this.message.showEffectiveSection = this.message.showEffectiveActionButtons = false;
    }

    setTimeout(() => { this.setUpdateType(status) }, 1500);
    this.markTypeAsMandatory(status);
    setTimeout(() => { this.flexibleComponent.main() });
  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "owner") {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted';
      return this.qualityService.validSwitchStatus;
    } else {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted' && status != 'Closed'
      return this.qualityService.validSwitchStatus;
    };
  }

  draft_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = this.isUsersLock = !isInitiator;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isInitiator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isInitiator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isInitiator;
  }

  dept_head_approval_aesthetic(isDeptHead: boolean, isEditableByDeptHead: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isDeptHead && isEditableByDeptHead);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isDeptHead;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isDeptHead && isEditableByDeptHead;
  }

  dept_head_approved_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showPreActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  pending_qa_acceptance_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  closure_rejected_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !isOwner;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isOwner;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isOwner;
  }

  owner_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !isOwner;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isOwner;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isOwner;
  }

  pending_qa_approval_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isQa && isEditableByQa;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isQa && isEditableByQa;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  qa_approved_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  initial_review_aesthetic(isReviewer: boolean, isEditableByReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isReviewer && isEditableByReviewer);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isReviewer && isEditableByReviewer;
  }

  initial_approval_aesthetic(isApprover: boolean, isEditableByApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isApprover && isEditableByApprover);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isApprover && isEditableByApprover;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isApprover && isEditableByApprover;
  }

  inprogress_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false; /* Locked in Stage Users Component */
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  closure_review_aesthetic(isReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  closure_approval_aesthetic(isApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  freeze_aesthetic_A(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean, status: string) {

    let grantFileAccess: boolean = false;

    if (status == 'Pending Delete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Delete Approver")
    } else if (status == 'Pending Revoke Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Revoke Approver")
    } else if (status == 'Pending Obsolete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Obsolete Approver")
    } else if (status == 'Pending Reopen Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Reopen Approver")
    } else if (status == 'Closed') {
      grantFileAccess = isOwner
    }

    this.isFrozen = true;
    this.message.showCRDetailsSection = status != 'Pending Delete Approval';
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = grantFileAccess;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  freeze_aesthetic_B(isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = false;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledged',
      'Owner Acknowledgement Pending'
    ]);

    this.showUpdateType = !statuses.has(status);
    setTimeout(() => { this.isUpdateType = this.showUpdateType && !this.isFrozen; }, 1500);
  }

  isTypeMandatory: boolean = false;
  private markTypeAsMandatory(status: string): void {
    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledgement Pending'
    ]);
    this.isTypeMandatory = !statuses.has(status)
  }

  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        this.selectBoxForFooter();
        this.reportFooterDropdown.length && (this.selectedReportFooter = this.reportFooterDropdown[0].displayExp);
      },
      error: (error: any) => {
        console.log('ngOnChangesReportFooter → getCodeListsByGroup', error)
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }
}
